<template>
  <transition name="fade">
    <div class="app-container"
         v-show="show">
      <transition name="bottom-slide-up">
        <div class="content--mark"
             v-show="show"></div>
      </transition>
      <div class="content">
        <transition name="left-img-animationg"
                    enter-active-class="animated left-scale-enter-active"
                    leave-active-class="animated left-slide-leave-active">
          <div class="content__left"
               v-show="show">
            <img src="../assets/images/main/logo-ch.png"
                 width="100%"
                 v-if="$i18n.locale === 'ch'" />
            <img src="../assets/images/main/logo-zh.png"
                 width="100%"
                 v-if="$i18n.locale === 'zh'" />
            <img src="../assets/images/main/logo-en.png"
                 width="100%"
                 v-if="$i18n.locale === 'en'" />
          </div>
        </transition>
        <transition name="right-slide">
          <div style="position: absolute; position: absolute;left: 400px;top: 32px;"
               v-show="show">
            <img src="../assets/images/main/1-ch.png"
                 width="100%"
                 v-if="$i18n.locale === 'ch'" />
            <img src="../assets/images/main/1-zh.png"
                 width="100%"
                 v-if="$i18n.locale === 'zh'" />
            <img src="../assets/images/main/1-en.png"
                 width="100%"
                 style="position: relative;bottom: 20px;"
                 v-if="$i18n.locale === 'en'" />
          </div>
        </transition>
        <transition name="left-slide">
          <div style="position: absolute; position: absolute;left: 15px;top: 380px;"
               v-show="show">
            <img src="../assets/images/main/2-ch.png"
                 width="100%"
                 v-if="$i18n.locale === 'ch'" />
            <img src="../assets/images/main/2-zh.png"
                 width="100%"
                 v-if="$i18n.locale === 'zh'" />
            <img src="../assets/images/main/2-en.png"
                 width="100%"
                 style="position: relative;right: 50px;bottom: 42px;"
                 v-if="$i18n.locale === 'en'" />
          </div>
        </transition>
        <transition name="right-slide">
          <div style="position: absolute; position: absolute;left: 490px;top: 452px;"
               v-show="show">
            <img src="../assets/images/main/3-ch.png"
                 width="100%"
                 v-if="$i18n.locale === 'ch'" />
            <img src="../assets/images/main/3-zh.png"
                 width="100%"
                 v-if="$i18n.locale === 'zh'" />
            <img src="../assets/images/main/3-en.png"
                 width="100%"
                 style="position: relative;bottom: 3px;right: 40px;"
                 v-if="$i18n.locale === 'en'" />
          </div>
        </transition>

        <div class="content__right"
             v-if="$i18n.locale !== 'en'">
          <transition name="right-slide">
            <h2 v-show="show">About</h2>
          </transition>
          <transition name="left-slide">
            <h4 v-show="show">{{ $t("title") }}</h4>
          </transition>
          <transition name="right-slide">
            <p v-show="show">
              {{ $t("content") }}
            </p>
          </transition>
          <transition name="left-slide">
            <ul v-show="show">
              <li>{{ $t("one") }}</li>
              <li>{{ $t("two") }}</li>
              <li>{{ $t("three") }}</li>
            </ul>
          </transition>
        </div>
        <div class="content__right"
             v-else>
          <transition name="right-slide">
            <h2 v-show="show">About</h2>
          </transition>
          <transition name="left-slide">
            <h4 v-show="show">{{ $t("title") }}</h4>
          </transition>
          <transition name="right-slide">
            <p v-show="show"
               style="line-height:28px;">
              {{ $t("content") }}
            </p>
          </transition>
          <transition name="left-slide">
            <ul v-show="show">
              <li style="font-size: 14px;">{{ $t("one") }}</li>
              <li style="font-size: 14px;">{{ $t("two") }}</li>
              <li style="font-size: 14px;">{{ $t("three") }}</li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>
<i18n>
{
  "ch": {
    "title": "关于优托邦UTOPA",
    "content": "优托邦(UTOPA)是一个拥有全新商业理念的新经济服务平台，以人为核心，探索人与人、人与自然、人与科技的关系，用科技智能手法将实体、线上、虚拟相联结，创建多维度欢乐社交空间。优托邦UTOPA创新设计实体和线上主题场景，强调丰富体验，满足全方位社交需求。旗下拥有时尚、餐饮、儿童、运动、艺术生活、创新办公等覆盖全方位生活需求的主力品牌，并通过全球品牌客户关系合作网络，开发管理及运营近 250万㎡的商业项目。",
    "one": "为业主创造价值，提供资源",
    "two": "为商户创造收益，提供平台",
    "three": "为会员创造体验，提供服务"
  },
  "zh": {
    "title": "關於優托邦UTOPA",
    "content": "優托邦(UTOPA)是一個擁有全新商業理念的新經濟服務平臺，以人為核心，探索人與人、人與自然、人與科技的關係，用科技智慧手法將實體、線上、虛擬相聯結，創建多維度歡樂社交空間。優托邦UTOPA創新設計實體和線上主題場景，強調豐富體驗，滿足全方位社交需求。旗下擁有時尚、餐飲、兒童、運動、藝術生活、創新辦公等覆蓋全方位生活需求的主力品牌，並通過全球品牌客戶關係合作網路，開發管理及運營近 250萬㎡的商業專案。",
    "one": "為業主創造價值，提供資源",
    "two": "為商戶創造收益，提供平臺",
    "three": "為會員創造體驗，提供服務"
  },
  "en": {
    "title": "CORPORATE OVERVIEW",
    "content": "UTOPA is a new economy enterprise with strong people oriented vision. We explore relationships between human, nature and technology to create multi-dimensional social networks. Utopa perfectly displays wonderful lives brought by new economy and new retail through the integration of online, offline and virtual world. UTOPA curates its business themes to provide customers with unique experience and social satisfaction. Our commercial brands cover all aspects of life, including fashion, dining,  kids, sports, art and lifestyle and co-working spaces. Through close collaborations with our global partners, UTOPA is currently developing, managing and operating commercial properties with an aggregate contracted GFA of 2.5 million m².",
    "one": "Create values and provide resources to owners",
    "two": "Create profits and provide platforms to tenants",
    "three": "Create experience and provide services to members"
  }
}
</i18n>
<script>
export default {
  name: 'homeBanner',
  props: {
    show: [Boolean]
  }
}
</script>
<style lang="scss" scoped>
// 底部向上滑动动画
.bottom-slide-up-enter-active {
  animation: bottom-slide-up 0.5s ease-out;
}
.bottom-slide-up-leave-active {
  animation: bottom-slide-up 0.5s reverse ease-in;
}

// 左边缩放进入动画
.left-scale-enter-active {
  animation-name: fade-in, scale-in;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}

// 左边滑动进入动画
.left-slide-enter-active {
  animation-name: fade-in, left-slide;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}
.left-slide-leave-active {
  animation: left-slide 0.5s reverse ease-in;
}

// 右边滑动进入动画
.right-slide-enter-active {
  animation-name: fade-in, right-slide;
  animation-duration: 0.2s;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}
.right-slide-leave-active {
  animation: right-slide 0.5s reverse ease-in;
}

@keyframes bottom-slide-up {
  0% {
    top: 90%;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 0;
  }
}

@keyframes scale-in {
  0% {
    transform: scale(0.2);
    transform-origin: bottom left;
  }
  50% {
    transform: scale(0.6);
    transform-origin: bottom left;
  }
  100% {
    transform: scale(1);
    transform-origin: bottom left;
  }
}

@keyframes left-slide {
  0% {
    transform: translateX(-20%);
  }
  50% {
    transform: translateX(-10%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes right-slide {
  0% {
    transform: translateX(20%);
  }
  50% {
    transform: translateX(10%);
  }
  100% {
    transform: translateX(0);
  }
}

.app-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .content--mark {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background-image: linear-gradient(
      0deg,
      rgba(43, 58, 57, 0) 0%,
      #071824 38%,
      rgba(7, 24, 36, 0.8) 100%
    );
  }
  .content {
    position: relative;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    top: 120px;
    width: 70%;
    min-width: 1126px;
    min-height: 100px;
    &__left {
      width: 597px;
      min-height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    &__right {
      width: 450px;
      min-height: 100px;
      position: absolute;
      right: 0;
      color: #ffffff;
      h2 {
        font-size: 61px;
        color: rgba(255, 255, 255, 0.1);
        position: absolute;
        top: -35px;
        left: 95px;
      }
      h4 {
        font-size: 24px;
        letter-spacing: 0;
        text-align: right;
      }
      p {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 32px;
      }
      ul {
        li {
          font-size: 16px;
          letter-spacing: 0;
          line-height: 32px;
        }
        li:nth-child(1) {
          margin-left: 20px;
        }
        li:nth-child(2) {
          margin-left: 40px;
        }
        li:nth-child(3) {
          margin-left: 60px;
        }
      }
    }
  }
}
</style>
